var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar",class:_vm.bgClass},[_c('div',{ref:"backgroundBar"}),_c('div',{ref:"foregroundBar",class:_vm.fgClass})])}
var staticRenderFns = []

export { render, staticRenderFns }